export default class DtoPgsseImport {
    constructor(obj) {
        this.id = obj.id // Option[Long] = None,
        this.idDiag = obj.idDiag // Option[Long] = None,
        this.phase = obj.phase // Option[Long] = None,
        this.fileName = obj.fileName // Option[String] = None,
        this.updateDate = obj.updateDate // Option[DateTime] = None,
        this.updateLogin = obj.updateLogin // Option[String] = None,
    }
}
